// extracted by mini-css-extract-plugin
export default {"tasks":"Lesson_tasks__oXYpF"};